module.exports = __webpack_public_path__ + "img/mango-2.1033a913.png";